
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/[...slug]",
      function () {
        return require("private-next-pages/settings/[...slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/[...slug]"])
      });
    }
  